/**
 * La lecture de « Ma dispo » : la semaine, demandée au montage (`getAvailability`, rangée par le
 * réducteur `tutorAvailability`), et redemandée par « Réessayer ».
 *
 * La semaine n'est plus persistée (03/11 : vieille ou vide, elle se montrait une seconde avant la
 * vraie) : à l'ouverture de l'app, l'écran montre son squelette jusqu'à elle. Dans la séance, celle
 * d'un passage précédent se montre pendant la relecture. Quand la nôtre arrive, le brouillon repart d'elle (`onWeekLanded`) — gardé, il cacherait un
 * créneau que le serveur a gagné depuis, et l'enregistrement (un remplacement de toute la semaine)
 * l'effacerait. Comme `useRequestOnMount` dans `MaDispoScreen`.
 */
import { tutorAvailabilityService } from "../../../../../../data/services/tutorAvailabilityService"
import { useApiFetch } from "../../../hooks/useApiFetch"

export function useTutorAvailabilityData(onWeekLanded: () => void) {
    const { fetch } = useApiFetch({
        service: tutorAvailabilityService.getAvailability,
        onSuccess: () => onWeekLanded(),
    })
    return { retry: fetch }
}
